
import { defineComponent } from 'vue'
import { mdiPlayBoxOutline, mdiAccount, mdiCalendarCheck, mdiEmailCheck } from '@mdi/js'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: { BaseIconText },
  setup() {
    return {
      mdiPlayBoxOutline,
      mdiAccount,
      mdiCalendarCheck,
      mdiEmailCheck,
    }
  },
})
